import { useSelector } from 'react-redux'

import { makeSelectPermissions } from '@webapp/core/stores/global'
import { type PermissionEnum } from '@webapp/platform/iam'
import { hasPermission } from '@webapp/utils/permissions'

export const useCheckPermission = (permission: PermissionEnum): boolean => {
  const permissions = useSelector(makeSelectPermissions()) || []

  return hasPermission(permissions, permission)
}
